// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  listCredential,
  listByManagedCluster,
  $delete,
  update,
  createOrUpdate,
  get,
} from "./operations.js";
export type {
  ManagedNamespacesListCredentialOptionalParams,
  ManagedNamespacesListByManagedClusterOptionalParams,
  ManagedNamespacesDeleteOptionalParams,
  ManagedNamespacesUpdateOptionalParams,
  ManagedNamespacesCreateOrUpdateOptionalParams,
  ManagedNamespacesGetOptionalParams,
} from "./options.js";
